// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-144dcdd0] {\n  position: relative;\n  border-left: 1px solid #dfe4ef;\n  border-right: 1px solid #dfe4ef;\n}\n.list .list-observer[data-v-144dcdd0] {\n    position: absolute;\n    bottom: -1px;\n}\n@media (max-width: 767.98px) {\n.list[data-v-144dcdd0] {\n      margin-left: -20px;\n      margin-right: -20px;\n      border: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
